export class GeneralInformation {
  generalCountryInformationId?: number;
  description: string;
  countryId?: number;
  countryName?: string;
  generalCountryInformationTypeId?: number;
  generalCountryInformationTypeName?: string;
  isActive?: boolean;
  isApproved?: boolean;
  approvedOn?: Date;
  actualFrom?: Date;
  newsDate?: Date;
  reviewDate?: Date;
  modified?: Date;

  constructor({
    generalCountryInformationId,
    description,
    countryId,
    countryName,
    generalCountryInformationTypeId,
    generalCountryInformationTypeName,
    actualFrom,
    reviewDate,
    modified,
  }: GeneralInformation) {
    this.generalCountryInformationId = generalCountryInformationId;
    this.description = description ?? '';
    this.countryId = countryId;
    this.countryName = countryName;
    this.generalCountryInformationTypeId = generalCountryInformationTypeId;
    this.generalCountryInformationTypeName = generalCountryInformationTypeName;
    this.actualFrom = actualFrom;
    this.reviewDate = reviewDate;
    this.modified = modified;
  }
}
